import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Field, Form, Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import RouteSupervisorStore from "./store/routeSupervisorStore";
const AddRouteSupervisorModal = ({ showModal, setShow, selectedData }) => {
    const handleClose = () => setShow(false)
    const { addRouteSupervisorData, fetchRouteSupervisorData, updateRouteSupervisorData } = RouteSupervisorStore()
    const initialValues = {
        supervisorName: selectedData ? selectedData.routeSupervisorName : '',
        mobileNumber: selectedData ? selectedData.mobileNumber : '',
        emailId: selectedData ? selectedData.emailId : null,
        status: selectedData ? String(selectedData.isActive) : "true",
    }

    const validationSchema = Yup.object().shape({
        supervisorName: Yup.string()
            // .matches(/^[A-Za-z ]+$/, 'Supervisor Name must contain only alphabets and spaces')
            .min(2, 'Too Short!')
            .max(50, 'Too Long!')
            .required('Supervisor Name is Required'),
        mobileNumber: Yup.string()
            .matches(/^\+?[6-9]\d{9}$/, "Mobile number must be exactly 10 digits and start with 6, 7, 8, or 9")
            .required("Mobile number is required"),
        emailId: Yup.string()
            .trim()
            .nullable()
            .matches(
                /^$|^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                'Please enter a valid email address'
            ),

    })


    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        const updatedValues = { ...values, status: values.status === 'true' }
        let response
        if (selectedData) {
            response = await updateRouteSupervisorData({ ...updatedValues, id: selectedData.routeSupervisorId })
        } else {
            response = await addRouteSupervisorData(updatedValues)
        }
        // const response = await addRouteSupervisorData(updatedValues)
        if (response.success === true) {
            resetForm();
            handleClose();
            fetchRouteSupervisorData()
        }
        setSubmitting(false);

    };

    const handleKeyPress = (event) => {
        const char = event.key;
        const value = event.target.value;
        // Allow only numbers and '+' (only at the start)
        if (!/[0-9]/.test(char) && !(char === "+" && value === "")) {
            event.preventDefault();
        }
    };


    return (
        <Modal
            show={showModal}
            size="lg"
            aria-labelledby="example-modal-sizes-title-lg"
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    {selectedData ? "Edit Route Superviosr" : " Add Route Superviosr"}
                </Modal.Title>
                <i
                    className="fa-solid fa-xmark close-container"
                    onClick={handleClose}
                ></i>
            </Modal.Header>
            <hr />
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    validateOnChange={true}
                    validateOnBlur={true}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="supervisorName">
                                        Route Supervisor Name <span className="text-danger">*</span>
                                    </label>
                                    <Field
                                        name="supervisorName"

                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Supervisor Name"
                                                maxLength={50}
                                                // onInput={(e) => {
                                                //     e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '');
                                                // }}
                                                onInput={(e) => {
                                                    let value = e.target.value;

                                                    // Allow A-Z, a-z, 0-9, space, /, and -
                                                    // value = value.replace(/[^A-Za-z0-9 ]/g, '');
                                                    value = value.replace(/\s+/g, ' ');

                                                    // Remove leading and trailing spaces
                                                    value = value.trimStart();

                                                    e.target.value = value;
                                                }}
                                            />
                                        )}
                                    />

                                    <ErrorMessage name="supervisorName" component="div" style={{ color: 'red' }} className='small' />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="mobileNumber">
                                        Mobile Number <span className="text-danger">*</span>
                                    </label>
                                    <Field
                                        // type="tel" // Use tel for mobile keyboard
                                        name="mobileNumber"
                                        className='form-control'
                                        placeholder="Enter Mobile Number"
                                        maxLength={10} // Allow 10 digits + optional '+'
                                        onKeyPress={handleKeyPress} // Restrict input to numbers and '+'
                                    />
                                    <ErrorMessage name="mobileNumber" component="div" style={{ color: 'red' }} className='small' />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="emailId">
                                        Email Id
                                    </label>
                                    <Field
                                        type="text"
                                        name="emailId"
                                        placeholder="Enter Email"
                                        className="form-control"
                                    />
                                    <ErrorMessage name="emailId" component="div" style={{ color: 'red' }} className="small" />
                                </div>
                                <div className="col-md-8 ">
                                    <label className="form-label">
                                        Status<span style={{ color: "#EC1117" }}> *</span>
                                    </label>
                                    <div className="form-group" style={{ display: "flex", alignItems: 'center' }}>
                                        <div className="form-check d-flex">
                                            <Field
                                                type="radio"
                                                className="form-check-input"
                                                name="status"
                                                id="activeRadio"
                                                value="true"
                                            />
                                            <label className="form-check-label" htmlFor="activeRadio">
                                                Active
                                            </label>
                                        </div>
                                        <div className="form-check ms-4 d-flex">
                                            <Field
                                                type="radio"
                                                className="form-check-input"
                                                name="status"
                                                id="inactiveRadio"
                                                value="false"
                                            />
                                            <label className="form-check-label" htmlFor="inactiveRadio">
                                                Inactive
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-center">
                                {/* {canWriteValue === true ? */}
                                <button type="submit" className="deployment-button" disabled={isSubmitting}>
                                    <i class="fa-solid fa-check done-container"></i>
                                    {selectedData ? ("Update") : ("Save")}
                                    {/* Save */}
                                </button>
                                {/* : ''} */}
                            </div>
                        </Form>

                    )}

                </Formik>
            </Modal.Body>

        </Modal >
    )
}

export default AddRouteSupervisorModal